export const onProgressModel = (event) => {
	// console.log(`${event.detail.totalProgress * 100}%`);
	const progressBar = event.target.querySelector(".progress-bar");
	const updatingBar = event.target.querySelector(".update-bar");
	updatingBar.style.width = `${event.detail.totalProgress * 100}%`;
	if (event.detail.totalProgress === 1) {
		progressBar.classList.add("hide");
	} else {
		progressBar.classList.remove("hide");
	}
};
